import { Box } from "@mui/material";

const Header = ({title,description}) => {
  return (
    <Box sx={{ width: "100%" }}>
      <h4>{title}</h4>
      <p>{description}</p>
    </Box>
  )
}

export default Header